module.exports = __webpack_public_path__ + "static/uniLogo-ceff60658954e0f0b8894fc228dcf373.png";